export const uiInputMode = (): 'md' => {
  return 'md';
};
